import React from 'react';
import TextButton, { TextButtonProps } from '../../../../../Buttons/TextButton';
import { MODAL_FOOTER_BUTTON_SIZE, MODAL_FOOTER_PRIMARY_BUTTON_MIN_WIDTH } from '../../../Modal';
import s from './CancelButton.scss';

interface Props extends Omit<TextButtonProps, 'size' | 'variant'> {}

const CancelButton: React.FC<Props> = ({ children, ...rest }) => {
  return (
    <TextButton
      size={MODAL_FOOTER_BUTTON_SIZE}
      style={{ minWidth: MODAL_FOOTER_PRIMARY_BUTTON_MIN_WIDTH }}
      variant="main"
      className={s['root']}
      {...rest}
    >
      {children}
    </TextButton>
  );
};
CancelButton.displayName = 'CancelButton';

export default CancelButton;
